/* eslint-disable @typescript-eslint/naming-convention */
import { ModelsState } from 'src_common/common/websocket2/ModelsState';
import { ReduxRawState } from 'src/AppState/Redux/utils/ReduxRawState';
import {
    OpenapiProxyStaffAssetFlowsCsvParamsType,
    openapiProxyStaffAssetFlowsCsvRequest,
    OpenapiProxyStaffAssetFlowsCsvResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_asset_flows_csv';
import { ModelsStateSocketConfig } from 'src_common/common/websocket2/ModelsStateSocketConfig';
import { openapiProxyStaffCustomerWalletRequest } from 'src/api_openapi/generated/openapi_proxy_staff_customer_wallet';
import { Session } from 'src_common/sdk/session';
import {
    OpenapiSocketApiStaffUpdateSelectionParamsType,
    openapiSocketApiStaffUpdateSelectionRequest,
    OpenapiSocketApiStaffUpdateSelectionResponse200Type,
} from 'src/api_openapi/generated/openapi_socket_api_staff_update_selection';
import {
    OpenapiSocketApiStaffUpdateSelectionFeedSettingsParamsType,
    openapiSocketApiStaffUpdateSelectionFeedSettingsRequest,
} from 'src/api_openapi/generated/openapi_socket_api_staff_update_selection_feed_settings';
import {
    OpenapiSocketApiStaffUpdateSelectionPriceParamsType,
    openapiSocketApiStaffUpdateSelectionPriceRequest,
} from 'src/api_openapi/generated/openapi_socket_api_staff_update_selection_price';
import {
    openapiProxyTableauEmbeddedCreateLinkRequest,
    OpenapiProxyTableauEmbeddedCreateLinkResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_tableau_embedded_create_link';
import {
    openapiProxyTableauBackofficeAccessChangeRequest,
    OpenapiProxyTableauBackofficeAccessChangeResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_tableau_backoffice_access_change';
import {
    openapiProxyStaffAccountAffordabilityRequest,
    OpenapiProxyStaffAccountAffordabilityResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_account_affordability';
import {
    OpenapiProxyStaffAccountAffordabilityChangeStatusParamsType,
    openapiProxyStaffAccountAffordabilityChangeStatusRequest,
    OpenapiProxyStaffAccountAffordabilityChangeStatusResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_account_affordability_change_status';
import {
    OpenapiProxyStaffAccountAffordabilityManualCheckParamsType,
    openapiProxyStaffAccountAffordabilityManualCheckRequest,
    OpenapiProxyStaffAccountAffordabilityManualCheckResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_account_affordability_manual_check';

import {
    OpenapiProxyStaffAffordabilityCheckAuditParamsType,
    openapiProxyStaffAffordabilityCheckAuditRequest,
    OpenapiProxyStaffAffordabilityCheckAuditResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_affordability_check_audit';
import {
    OpenapiProxyStaffAccountAffordabilityFetchAllParamsType,
    openapiProxyStaffAccountAffordabilityFetchAllRequest,
    OpenapiProxyStaffAccountAffordabilityFetchAllResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_account_affordability_fetch_all';
import {
    OpenapiProxyStaffAccountAffordabilityCheckParamsType,
    openapiProxyStaffAccountAffordabilityCheckRequest,
    OpenapiProxyStaffAccountAffordabilityCheckResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_account_affordability_check';
import {
    OpenapiProxyStaffSrgUserAnswerParamsType,
    openapiProxyStaffSrgUserAnswerRequest,
    OpenapiProxyStaffSrgUserAnswerResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_srg_user_answer';
import {
    OpenapiProxyStaffAllTransactionsGetListParamsType,
    openapiProxyStaffAllTransactionsGetListRequest,
    OpenapiProxyStaffAllTransactionsGetListResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_all_transactions_get_list';
import {
    OpenapiProxyStaffTransactionsStatusUpdateParamsType,
    openapiProxyStaffTransactionsStatusUpdateRequest,
    OpenapiProxyStaffTransactionsStatusUpdateResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_transactions_status_update';
import {
    openapiSocketGetMarketRequest,
    OpenapiSocketGetMarketResponse200Type,
} from 'src/api_openapi/generated/openapi_socket_get_market';
import {
    openapiSocketApiStaffTagListRequest,
    OpenapiSocketApiStaffTagListResponse200Type,
} from 'src/api_openapi/generated/openapi_socket_api_staff_tag_list';
import { Resource } from 'src_common/common/mobx-utils/Resource';
import {
    openapiSocketApiStaffTriggerUpdateEventRequest,
    OpenapiSocketApiStaffTriggerUpdateEventResponse200Type,
} from 'src/api_openapi/generated/openapi_socket_api_staff_trigger_update_event';
import {
    openapiSocketApiStaffTriggerUpdateMarketRequest,
    OpenapiSocketApiStaffTriggerUpdateMarketResponse200Type,
} from 'src/api_openapi/generated/openapi_socket_api_staff_trigger_update_market';
import {
    OpenapiProxyStaffSelectionResultParamsType,
    openapiProxyStaffSelectionResultRequest,
    OpenapiProxyStaffSelectionResultResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_selection_result';
import {
    OpenapiProxyStaffSelectionSettleParamsType,
    openapiProxyStaffSelectionSettleRequest,
    OpenapiProxyStaffSelectionSettleResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_selection_settle';
import {
    OpenapiProxyStaffSelectionUnsettleParamsType,
    openapiProxyStaffSelectionUnsettleRequest,
    OpenapiProxyStaffSelectionUnsettleResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_selection_unsettle';
import {
    OpenapiProxyStaffSelectionResultGroupParamsType,
    openapiProxyStaffSelectionResultGroupRequest,
    OpenapiProxyStaffSelectionResultGroupResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_selection_result_group';
import {
    OpenapiProxyStaffSelectionSettleGroupParamsType,
    openapiProxyStaffSelectionSettleGroupRequest,
    OpenapiProxyStaffSelectionSettleGroupResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_selection_settle_group';
import {
    OpenapiProxyStaffDividendsAddParamsType,
    openapiProxyStaffDividendsAddRequest,
    OpenapiProxyStaffDividendsAddResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_dividends_add';
import {
    OpenapiProxyStaffDividendsUpdateParamsType,
    openapiProxyStaffDividendsUpdateRequest,
    OpenapiProxyStaffDividendsUpdateResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_dividends_update';
import {
    OpenapiProxyStaffRule4AddParamsType,
    openapiProxyStaffRule4AddRequest,
    OpenapiProxyStaffRule4AddResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_rule4_add';
import {
    OpenapiProxyStaffRule4UpdateParamsType,
    openapiProxyStaffRule4UpdateRequest,
    OpenapiProxyStaffRule4UpdateResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_rule4_update';
import {
    OpenapiProxyStaffEventReorderMarketsParamsType,
    openapiProxyStaffEventReorderMarketsRequest,
    OpenapiProxyStaffEventReorderMarketsResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_event_reorder_markets';
import {
    openapiProxyStaffPossibleMarketsRequest,
    OpenapiProxyStaffPossibleMarketsResponse200Type,
    OpenapiProxyStaffPossibleMarketsParamsType,
} from 'src/api_openapi/generated/openapi_proxy_staff_possible_markets';
import {
    OpenapiProxyUpdateEventParamsType,
    openapiProxyUpdateEventRequest,
    OpenapiProxyUpdateEventResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_update_event';

import {
    OpenapiProxyStaffCreateSelectionParamsType,
    openapiProxyStaffCreateSelectionRequest,
    OpenapiProxyStaffCreateSelectionResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_create_selection';
import {
    OpenapiProxyStaffUpdateMultiSelectionParamsType,
    openapiProxyStaffUpdateMultiSelectionRequest,
    OpenapiProxyStaffUpdateMultiSelectionResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_update_multi_selection';
import {
    OpenapiProxyStaffEventReorderSelectionsParamsType,
    openapiProxyStaffEventReorderSelectionsRequest,
    OpenapiProxyStaffEventReorderSelectionsResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_event_reorder_selections';

import {
    OpenapiProxyStaffFreebetHistoryParamsType,
    openapiProxyStaffFreebetHistoryRequest,
    OpenapiProxyStaffFreebetHistoryResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_freebet_history';

import {
    OpenapiProxyStaffFreebetAddCreditParamsType,
    openapiProxyStaffFreebetAddCreditRequest,
    OpenapiProxyStaffFreebetAddCreditResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_freebet_add_credit';

import {
    OpenapiProxyStaffFreebetCreditsParamsType,
    openapiProxyStaffFreebetCreditsRequest,
    OpenapiProxyStaffFreebetCreditsResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_freebet_credits';

import {
    OpenapiProxyStaffFreebetEnableCreditParamsType,
    openapiProxyStaffFreebetEnableCreditRequest,
    OpenapiProxyStaffFreebetEnableCreditResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_freebet_enable_credit';
import {
    openapiProxyStaffNetDepositRequest,
    OpenapiProxyStaffNetDepositResponse200Type,
    OpenapiProxyStaffNetDepositParamsType,
} from 'src/api_openapi/generated/openapi_proxy_staff_net_deposit';
import {
    OpenapiProxyStaffDepositParamsType,
    openapiProxyStaffDepositRequest,
    OpenapiProxyStaffDepositResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_deposit';
import {
    OpenapiProxyStaffSetSrgStatusParamsType,
    openapiProxyStaffSetSrgStatusRequest,
    OpenapiProxyStaffSetSrgStatusResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_set_srg_status';

import {
    OpenapiProxyStaffSetPofStatusParamsType,
    openapiProxyStaffSetPofStatusRequest,
    OpenapiProxyStaffSetPofStatusResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_set_pof_status';

import {
    OpenapiProxyStaffSetComplianceRestrictionParamsType,
    OpenapiProxyStaffSetComplianceRestrictionResponse200Type,
    openapiProxyStaffSetComplianceRestrictionRequest,
} from 'src/api_openapi/generated/openapi_proxy_staff_set_compliance_restriction';

import {
    OpenapiProxyStaffWithdrawalsParamsType,
    openapiProxyStaffWithdrawalsRequest,
    OpenapiProxyStaffWithdrawalsResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_withdrawals';
import {
    OpenapiProxyStaffCustomerManualAdjustmentConfirmParamsType,
    openapiProxyStaffCustomerManualAdjustmentConfirmRequest,
    OpenapiProxyStaffCustomerManualAdjustmentConfirmResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_customer_manual_adjustment_confirm';

import { StaffAccountWalletDataFormattedType } from 'src/AppState/Models/UserModel';
import { CurrencyType, isCurrencyCode } from 'src_common/common/amount/website-money/currency';

import {
    openapiProxyStaffSportsRequest,
    OpenapiProxyStaffSportsResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_sports';
import {
    OpenapiProxyStaffCompetitionsReorderParamsType,
    openapiProxyStaffCompetitionsReorderRequest,
    OpenapiProxyStaffCompetitionsReorderResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_competitions_reorder';
import {
    OpenapiProxyStaffCompetitionUpdateParamsType,
    openapiProxyStaffCompetitionUpdateRequest,
    OpenapiProxyStaffCompetitionUpdateResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_competition_update';
import { timeout } from 'src_common/common/mobx-utils/timeout';
import {
    OpenapiProxyStaffGetParticipantParamsType,
    openapiProxyStaffGetParticipantRequest,
    OpenapiProxyStaffGetParticipantResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_get_participant';
import {
    OpenapiProxyStaffGetCompetitionsParamsType,
    openapiProxyStaffGetCompetitionsRequest,
    OpenapiProxyStaffGetCompetitionsResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_get_competitions';
import {
    OpenapiProxyStaffSetPlayBreakParamsType,
    openapiProxyStaffSetPlayBreakRequest,
    OpenapiProxyStaffSetPlayBreakResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_set_play_break';
import {
    OpenapiProxyStaffGetRealityCheckResponse200Type,
    openapiProxyStaffGetRealityCheckRequest,
    OpenapiProxyStaffGetRealityCheckParamsType,
} from 'src/api_openapi/generated/openapi_proxy_staff_get_reality_check';

import {
    OpenapiProxyStaffSetRealityCheckParamsType,
    openapiProxyStaffSetRealityCheckRequest,
    OpenapiProxyStaffSetRealityCheckResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_set_reality_check';

import {
    OpenapiProxyStaffSetSelfExclusionParamsType,
    openapiProxyStaffSetSelfExclusionRequest,
    OpenapiProxyStaffSetSelfExclusionResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_set_self_exclusion';

import {
    OpenapiProxyStaffRequestReactivationSelfExclusionParamsType,
    openapiProxyStaffRequestReactivationSelfExclusionRequest,
    OpenapiProxyStaffRequestReactivationSelfExclusionResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_request_reactivation_self_exclusion';

import {
    OpenapiProxyStaffReactivateSelfExclusionParamsType,
    openapiProxyStaffReactivateSelfExclusionRequest,
    OpenapiProxyStaffReactivateSelfExclusionResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_reactivate_self_exclusion';

export const getCurrency = (currency: string): CurrencyType => {
    if (isCurrencyCode(currency)) {
        return currency;
    } else {
        console.error('wrong currency literal:', currency);
        return 'XTS';
    }
};

import {
    OpenapiProxyStaffCreateEventMarketParamsType,
    openapiProxyStaffCreateEventMarketRequest,
    OpenapiProxyStaffCreateEventMarketResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_create_event_market';
import {
    OpenapiProxyStaffUnsettleGroupParamsType,
    openapiProxyStaffUnsettleGroupRequest,
    OpenapiProxyStaffUnsettleGroupResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_unsettle_group';
import {
    OpenapiProxyStaffUpdateParticipantsParamsType,
    openapiProxyStaffUpdateParticipantsRequest,
    OpenapiProxyStaffUpdateParticipantsResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_update_participants';
import {
    openapiProxyStaffSportRequest,
    OpenapiProxyStaffSportResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_sport';
import {
    OpenapiProxyCreateEventParamsType,
    openapiProxyCreateEventRequest,
    OpenapiProxyCreateEventResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_create_event';
import {
    OpenapiProxyStaffMarketTemplateUpdateParamsType,
    openapiProxyStaffMarketTemplateUpdateRequest,
    OpenapiProxyStaffMarketTemplateUpdateResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_market_template_update';
import {
    OpenapiProxyStaffCompetitionCreateParamsType,
    openapiProxyStaffCompetitionCreateRequest,
    OpenapiProxyStaffCompetitionCreateResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_competition_create';
import {
    OpenapiProxyStaffCreateMarketTemplateParamsType,
    openapiProxyStaffCreateMarketTemplateRequest,
    OpenapiProxyStaffCreateMarketTemplateResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_create_market_template';

import {
    openapiProxyStaffPatchUserPersonalDetailRequest,
    OpenapiProxyStaffPatchUserPersonalDetailResponse200Type,
    OpenapiProxyStaffPatchUserPersonalDetailParamsType,
} from 'src/api_openapi/generated/openapi_proxy_staff_patch_user_personal_detail';
import {
    openapiProxyStaffGetMarketTemplatesRequest,
    OpenapiProxyStaffGetMarketTemplatesResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_get_market_templates';
import {
    OpenapiProxyStaffMarketTemplateSelectionsUpdateParamsType,
    openapiProxyStaffMarketTemplateSelectionsUpdateRequest,
    OpenapiProxyStaffMarketTemplateSelectionsUpdateResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_market_template_selections_update';
import {
    OpenapiProxyStaffMarketTemplateSelectionsReorderParamsType,
    openapiProxyStaffMarketTemplateSelectionsReorderRequest,
    OpenapiProxyStaffMarketTemplateSelectionsReorderResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_market_template_selections_reorder';
import {
    OpenapiSocketApiStaffSportGradesAddParamsType,
    openapiSocketApiStaffSportGradesAddRequest,
} from 'src/api_openapi/generated/openapi_socket_api_staff_sport_grades_add';
import {
    OpenapiProxyStaffGetLiabilitiesParamsType,
    openapiProxyStaffGetLiabilitiesRequest,
    OpenapiProxyStaffGetLiabilitiesResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_get_liabilities';

import { SdkTrading } from 'src/domains/sportsbook/trading/sdk/sdkTrading';
import {
    openapiProxyStaffAccountStaffBasicDataRequest,
    OpenapiProxyStaffAccountStaffBasicDataResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_account_staff_basic_data';
import {
    OpenapiProxyStaffAuditEventParamsType,
    openapiProxyStaffAuditEventRequest,
    OpenapiProxyStaffAuditEventResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_audit_event';
import {
    OpenapiProxyStaffMarketTemplateReorderParamsType,
    openapiProxyStaffMarketTemplateReorderRequest,
    OpenapiProxyStaffMarketTemplateReorderResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_market_template_reorder';
import {
    OpenapiProxyStaffMarketTemplateSelectionsCreateParamsType,
    openapiProxyStaffMarketTemplateSelectionsCreateRequest,
    OpenapiProxyStaffMarketTemplateSelectionsCreateResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_market_template_selections_create';
import {
    OpenapiProxyStaffGetLiabilitiesMultiplesParamsType,
    openapiProxyStaffGetLiabilitiesMultiplesRequest,
    OpenapiProxyStaffGetLiabilitiesMultiplesResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_get_liabilities_multiples';
import { EventId, MarketId } from 'src_common/common/websocket2/id/WebsocketId';
import {
    OpenapiProxyStaffCreateParticipantParamsType,
    openapiProxyStaffCreateParticipantRequest,
    OpenapiProxyStaffCreateParticipantResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_create_participant';
import {
    OpenapiProxyStaffGetCompetitionByIdParamsType,
    openapiProxyStaffGetCompetitionByIdRequest,
    OpenapiProxyStaffGetCompetitionByIdResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_get_competition_by_id';
import { AppEnvParamsBrowser } from 'src/utils/appEnvParams';
import {
    OpenapiProxyStaffDeleteCardRealexParamsType,
    openapiProxyStaffDeleteCardRealexRequest,
    OpenapiProxyStaffDeleteCardRealexResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_delete_card_realex';
import {
    openapiProxyStaffPriceMasterLadderRequest,
    OpenapiProxyStaffPriceMasterLadderResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_price_master_ladder';
import {
    OpenapiProxyStaffSelectionResultAndSettleGroupParamsType,
    openapiProxyStaffSelectionResultAndSettleGroupRequest,
    OpenapiProxyStaffSelectionResultAndSettleGroupResponse200Type,
} from 'src/api_openapi/generated/openapi_proxy_staff_selection_result_and_settle_group';
import { SdkSettingsService } from 'src/domains/sportsbook/trading/sdk/sdkSettingsService';
import { TrpcClient } from 'src/AppState/TrpcClient';
import { accountBasicData } from 'src_server/types/accountData';
import { ApiGetCampaignsResponse200Type } from 'src/api_openapi/v2/bonus-engine/apiGetCampaigns';

export type SocketGetMarketResponseType = OpenapiSocketGetMarketResponse200Type;
export type StaffAccountBasicDataType = accountBasicData.SuccessResponseType;
export type StaffAccountStaffBasicDataType = OpenapiProxyStaffAccountStaffBasicDataResponse200Type;
export type StaffAccountWalletDataType = StaffAccountWalletDataFormattedType;
export type UpdateSelectionParams = OpenapiSocketApiStaffUpdateSelectionParamsType &
    OpenapiSocketApiStaffUpdateSelectionFeedSettingsParamsType &
    OpenapiSocketApiStaffUpdateSelectionPriceParamsType;
export type UpdateSelectionResponse = OpenapiSocketApiStaffUpdateSelectionResponse200Type;
export type AssetFlowsCsvType = OpenapiProxyStaffAssetFlowsCsvResponse200Type;
export type TagsType = OpenapiSocketApiStaffTagListResponse200Type;
export type SingleTagType = OpenapiSocketApiStaffTagListResponse200Type['definitions'];
export type TableauEmbeddedCreateLinkType = OpenapiProxyTableauEmbeddedCreateLinkResponse200Type;
export type TableauBackofficeAccessChangeType = OpenapiProxyTableauBackofficeAccessChangeResponse200Type;
export type PossibleMarketsType = OpenapiProxyStaffPossibleMarketsResponse200Type;
export type UpdateEventDataType = OpenapiProxyUpdateEventParamsType;
export type CreateEventDataType = OpenapiProxyCreateEventParamsType;
export type UpdateMultiSelectionParams = OpenapiProxyStaffUpdateMultiSelectionParamsType;
export type UpdateMultiSelection = UpdateMultiSelectionParams['requestBody'];
export type ReorderSelectionsBodyType = OpenapiProxyStaffEventReorderSelectionsParamsType;
export type NetDepositResponseType = OpenapiProxyStaffNetDepositResponse200Type;
export type CompetitionsType = OpenapiProxyStaffGetCompetitionsResponse200Type;
export type SportsListType = OpenapiProxyStaffSportsResponse200Type;
export type CompetitionsReorderParamsType = OpenapiProxyStaffCompetitionsReorderParamsType;
export type CompetitionsReorderResponseType = OpenapiProxyStaffCompetitionsReorderResponse200Type;
export type CompetitionUpdateParamsType = OpenapiProxyStaffCompetitionUpdateParamsType;
export type ParticipantsType = OpenapiProxyStaffGetParticipantResponse200Type;
export type ParticipantsUpdateBodyType = OpenapiProxyStaffUpdateParticipantsParamsType;
export type StaffSrgUserAnswerType = OpenapiProxyStaffSrgUserAnswerResponse200Type;
export type CampaignsListType = ApiGetCampaignsResponse200Type;

export interface ComplianceRestrictionParamsType {
    customer_id: number;
    requestBody: {
        complianceRestriction: {
            eventTime: string;
            pendingSuspensionTime: string;
            source: string;
        };
        srgStatus: 'not-started' | 'requested' | 'passed' | 'failed';
    };
}

export type SimplifiedTag = {
    name: string;
    label: string;
    values: Array<{
        id: string;
        isDefault: boolean;
        label: string;
    }>;
};

export type TagType = 'selection' | 'selection-template' | 'event' | 'competition' | 'market-template' | 'market';

export interface SdkCustomerConfig {
    socketJoinSport: boolean;
    oddsFormatShortDefault?: 'f' | 'd';
    reduxStore: ReduxRawState;
}

export class SdkStaff {
    public readonly session: Session;
    public readonly config: SdkCustomerConfig;
    public readonly models: ModelsState;
    public readonly platformTags: Resource<TagsType>;
    public readonly trading: SdkTrading;
    public readonly settingsService: SdkSettingsService;
    public readonly trpcClient: TrpcClient;
    public staffId: number | null = null;

    public constructor(
        session: Session,
        config: SdkCustomerConfig,
        envParamsBrowser: AppEnvParamsBrowser,
        trpcClient: TrpcClient
    ) {
        this.session = session;
        this.config = config;
        this.trpcClient = trpcClient;

        const apiEventListIncludes: Record<string, string[]> = config.socketJoinSport
            ? {
                  horseracing: ['internationalhorseracing', 'horseracingantepost'],
                  greyhoundracing: ['internationalgreyhoundracing'],
              }
            : {};

        const modelsStateSocketConfig = new ModelsStateSocketConfig({
            apiEventListIncludes: (): Record<string, string[]> => apiEventListIncludes,
            oddsFormatShort: (): 'f' | 'd' | 'a' => 'f',
        });

        this.models = new ModelsState(
            this.session.isBrowser(),
            modelsStateSocketConfig,
            this.session.websocketUrl //initData.websocket_host_v2,
        );
        this.trading = new SdkTrading(session, config, envParamsBrowser);
        this.settingsService = new SdkSettingsService(session, config, envParamsBrowser);
        this.platformTags = new Resource(async (): Promise<TagsType> => {
            return await this.session.call(openapiSocketApiStaffTagListRequest, {});
        });
    }

    public async getAllTags(): Promise<TagsType> {
        return this.session.call(openapiSocketApiStaffTagListRequest, {});
    }

    public getStaffId = (): number | null => {
        //@ts-expect-error
        return this.config.reduxStore.getState().user.toJS().data.id;
    };

    public async getBasicData(userId: number): Promise<StaffAccountBasicDataType> {
        const response = await this.trpcClient.client.accountData.getAccountBasicData.query({ userId });

        if (response.responseStatus === 'success') {
            return response.data;
        }

        throw new Error(`Failed to get account basic data: ${response.responseStatus}`);
    }

    public async getStaffBasicData(userId: number): Promise<StaffAccountStaffBasicDataType> {
        return await this.session.call(openapiProxyStaffAccountStaffBasicDataRequest, { user_id: userId });
    }

    public async getWalletData(userId: number): Promise<StaffAccountWalletDataType> {
        const response = await this.session.call(openapiProxyStaffCustomerWalletRequest, { customer_id: userId });
        const formattedCurrency = getCurrency(response.currency);

        return {
            ...response,
            currency: formattedCurrency,
            id: response.id,
            createdAt: response.createdAt,
            lastBetAt: response.lastBetAt,
            universe: response.universe,
            updatedAt: response.updatedAt,
            balance: response.balancePrecise,
            creditLimit: response.creditLimitPrecise,
            fundsLocked: response.fundsLockedPrecise,
            operatorAccumulatedProfit: response.operatorAccumulatedProfitPrecise,
            operatorBalance: response.operatorBalancePrecise,
            operatorExternalProfit: response.operatorExternalProfitPrecise,
            operatorProfit: response.operatorProfitPrecise,
            profit: response.profitPrecise,
            withdrawableBalance: response.withdrawableBalancePrecise,
            playableBalance: response.playableBalancePrecise,
            backofficeWithdrawableBalance: response.backofficeWithdrawableBalancePrecise,
        };
    }

    public getAffordabilityStatus(userId: number): Promise<OpenapiProxyStaffAccountAffordabilityResponse200Type> {
        return this.session.call(openapiProxyStaffAccountAffordabilityRequest, { user_id: userId });
    }

    public postAffordabilityStatus(
        requestBody: OpenapiProxyStaffAccountAffordabilityChangeStatusParamsType
    ): Promise<OpenapiProxyStaffAccountAffordabilityChangeStatusResponse200Type> {
        return this.session.call(openapiProxyStaffAccountAffordabilityChangeStatusRequest, requestBody);
    }

    public postAffordabilityManualCheck(
        requestBody: OpenapiProxyStaffAccountAffordabilityManualCheckParamsType
    ): Promise<OpenapiProxyStaffAccountAffordabilityManualCheckResponse200Type> {
        return this.session.call(openapiProxyStaffAccountAffordabilityManualCheckRequest, requestBody);
    }

    public postAffordabilityFetchAll(
        requestBody: OpenapiProxyStaffAccountAffordabilityFetchAllParamsType
    ): Promise<OpenapiProxyStaffAccountAffordabilityFetchAllResponse200Type> {
        return this.session.call(openapiProxyStaffAccountAffordabilityFetchAllRequest, requestBody);
    }

    public postAffordabilityCheck(
        requestBody: OpenapiProxyStaffAccountAffordabilityCheckParamsType
    ): Promise<OpenapiProxyStaffAccountAffordabilityCheckResponse200Type> {
        return this.session.call(openapiProxyStaffAccountAffordabilityCheckRequest, requestBody);
    }

    public postAffordabilityCheckAudit(
        requestBody: OpenapiProxyStaffAffordabilityCheckAuditParamsType
    ): Promise<OpenapiProxyStaffAffordabilityCheckAuditResponse200Type> {
        return this.session.call(openapiProxyStaffAffordabilityCheckAuditRequest, requestBody);
    }

    public getSrgUserAnswer(requestBody: OpenapiProxyStaffSrgUserAnswerParamsType): Promise<StaffSrgUserAnswerType> {
        return this.session.call(openapiProxyStaffSrgUserAnswerRequest, requestBody);
    }

    public postAllTransactionsList(
        requestBody: OpenapiProxyStaffAllTransactionsGetListParamsType
    ): Promise<OpenapiProxyStaffAllTransactionsGetListResponse200Type> {
        return this.session.call(openapiProxyStaffAllTransactionsGetListRequest, requestBody);
    }

    public patchTransactionStatusUpdate(
        requestBody: OpenapiProxyStaffTransactionsStatusUpdateParamsType
    ): Promise<OpenapiProxyStaffTransactionsStatusUpdateResponse200Type> {
        return this.session.call(openapiProxyStaffTransactionsStatusUpdateRequest, requestBody);
    }

    public updateSelection(
        params: UpdateSelectionParams,
        feedSettings?: boolean,
        price?: boolean
    ): Promise<UpdateSelectionResponse> {
        if (feedSettings === true) {
            return this.session.call(openapiSocketApiStaffUpdateSelectionFeedSettingsRequest, params);
        }

        if (price === true) {
            return this.session.call(openapiSocketApiStaffUpdateSelectionPriceRequest, params);
        }

        return this.session.call(openapiSocketApiStaffUpdateSelectionRequest, params);
    }

    public async updateSelectionPrice(params: OpenapiSocketApiStaffUpdateSelectionPriceParamsType): Promise<void> {
        await this.session.call(openapiSocketApiStaffUpdateSelectionPriceRequest, params);
    }

    public postAssetFlowsCsv(params: OpenapiProxyStaffAssetFlowsCsvParamsType): Promise<AssetFlowsCsvType> {
        return this.session.call(openapiProxyStaffAssetFlowsCsvRequest, params);
    }

    public socket_get_market(marketId: number): Promise<SocketGetMarketResponseType> {
        return this.session.call(openapiSocketGetMarketRequest, {
            id: marketId,
        });
    }

    public triggerUpdateEvent(eventId: EventId): Promise<OpenapiSocketApiStaffTriggerUpdateEventResponse200Type> {
        return this.session.call(openapiSocketApiStaffTriggerUpdateEventRequest, {
            requestBody: {
                eventId: eventId.toOldId(),
            },
        });
    }

    public triggerUpdateMarket(
        marketIdNew: MarketId
    ): Promise<OpenapiSocketApiStaffTriggerUpdateMarketResponse200Type> {
        const marketId = marketIdNew.toOldId();
        return this.session.call(openapiSocketApiStaffTriggerUpdateMarketRequest, { requestBody: { marketId } });
    }

    public tableauEmbeddedCreateLink(isProdMode: boolean, username: string): Promise<TableauEmbeddedCreateLinkType> {
        return this.session.call(openapiProxyTableauEmbeddedCreateLinkRequest, {
            requestBody: {
                isProdMode,
                username,
            },
        });
    }

    public getFreebetHistory(
        requestBody: OpenapiProxyStaffFreebetHistoryParamsType
    ): Promise<OpenapiProxyStaffFreebetHistoryResponse200Type> {
        return this.session.call(openapiProxyStaffFreebetHistoryRequest, requestBody);
    }

    public postAddFreebetCredit(
        requestBody: OpenapiProxyStaffFreebetAddCreditParamsType
    ): Promise<OpenapiProxyStaffFreebetAddCreditResponse200Type> {
        return this.session.call(openapiProxyStaffFreebetAddCreditRequest, requestBody);
    }

    public getFreebetCredit(
        requestBody: OpenapiProxyStaffFreebetCreditsParamsType
    ): Promise<OpenapiProxyStaffFreebetCreditsResponse200Type> {
        return this.session.call(openapiProxyStaffFreebetCreditsRequest, requestBody);
    }

    public patchFreebetEnableCredit(
        requestBody: OpenapiProxyStaffFreebetEnableCreditParamsType
    ): Promise<OpenapiProxyStaffFreebetEnableCreditResponse200Type> {
        return this.session.call(openapiProxyStaffFreebetEnableCreditRequest, requestBody);
    }

    public depositInitiate(
        params: OpenapiProxyStaffDepositParamsType
    ): Promise<OpenapiProxyStaffDepositResponse200Type> {
        return this.session.call(openapiProxyStaffDepositRequest, params);
    }

    public tableauBackofficeAccessChange({
        staffId,
        tableauAccessLogin,
    }: {
        staffId: number;
        tableauAccessLogin: string;
    }): Promise<TableauBackofficeAccessChangeType> {
        return this.session.call(openapiProxyTableauBackofficeAccessChangeRequest, {
            staff_id: staffId,
            requestBody: {
                tableauAccessLogin,
            },
        });
    }

    public getTags = (eventId: number, type: TagType): Array<SimplifiedTag> => {
        const event = this.models.getEvent(eventId);
        const tags = this.platformTags.get();

        if (event === null || tags.type !== 'ready') {
            return [];
        }
        const sport = event.sport;
        const filteredTAgs: Array<SimplifiedTag> = [];
        for (const [id, tag] of Object.entries(tags.value.definitions)) {
            if (tag.applicableTo.includes(type) === true && tag.sports.includes(sport) === true) {
                filteredTAgs.push({
                    name: id,
                    label: tag.label,
                    values: tag.values,
                });
            }
        }

        return filteredTAgs;
    };

    public selection_result(
        requestBody: OpenapiProxyStaffSelectionResultParamsType
    ): Promise<OpenapiProxyStaffSelectionResultResponse200Type> {
        return this.session.call(openapiProxyStaffSelectionResultRequest, requestBody);
    }

    public selection_settle(
        requestBody: OpenapiProxyStaffSelectionSettleParamsType
    ): Promise<OpenapiProxyStaffSelectionSettleResponse200Type> {
        return this.session.call(openapiProxyStaffSelectionSettleRequest, requestBody);
    }

    public selection_unsettle(
        requestBody: OpenapiProxyStaffSelectionUnsettleParamsType
    ): Promise<OpenapiProxyStaffSelectionUnsettleResponse200Type> {
        return this.session.call(openapiProxyStaffSelectionUnsettleRequest, requestBody);
    }

    public selection_result_group(
        requestBody: OpenapiProxyStaffSelectionResultGroupParamsType
    ): Promise<OpenapiProxyStaffSelectionResultGroupResponse200Type> {
        return this.session.call(openapiProxyStaffSelectionResultGroupRequest, requestBody);
    }
    public selection_result_and_settle_group(
        requestBody: OpenapiProxyStaffSelectionResultAndSettleGroupParamsType
    ): Promise<OpenapiProxyStaffSelectionResultAndSettleGroupResponse200Type> {
        return this.session.call(openapiProxyStaffSelectionResultAndSettleGroupRequest, requestBody);
    }

    public staff_selection_settle_group(
        requestBody: OpenapiProxyStaffSelectionSettleGroupParamsType
    ): Promise<OpenapiProxyStaffSelectionSettleGroupResponse200Type> {
        return this.session.call(openapiProxyStaffSelectionSettleGroupRequest, requestBody);
    }

    public withdraw(
        params: OpenapiProxyStaffWithdrawalsParamsType
    ): Promise<OpenapiProxyStaffWithdrawalsResponse200Type> {
        return this.session.call(openapiProxyStaffWithdrawalsRequest, params);
    }

    public manual_adjustment_confirm(
        params: OpenapiProxyStaffCustomerManualAdjustmentConfirmParamsType
    ): Promise<OpenapiProxyStaffCustomerManualAdjustmentConfirmResponse200Type> {
        return this.session.call(openapiProxyStaffCustomerManualAdjustmentConfirmRequest, params);
    }

    public staff_selection_dividends_add(
        requestBody: OpenapiProxyStaffDividendsAddParamsType
    ): Promise<OpenapiProxyStaffDividendsAddResponse200Type> {
        return this.session.call(openapiProxyStaffDividendsAddRequest, requestBody);
    }

    public staff_selection_dividends_update(
        requestBody: OpenapiProxyStaffDividendsUpdateParamsType
    ): Promise<OpenapiProxyStaffDividendsUpdateResponse200Type> {
        return this.session.call(openapiProxyStaffDividendsUpdateRequest, requestBody);
    }

    public staff_selection_rule4_add(
        requestBody: OpenapiProxyStaffRule4AddParamsType
    ): Promise<OpenapiProxyStaffRule4AddResponse200Type> {
        return this.session.call(openapiProxyStaffRule4AddRequest, requestBody);
    }

    public staff_selection_rule4_update(
        requestBody: OpenapiProxyStaffRule4UpdateParamsType
    ): Promise<OpenapiProxyStaffRule4UpdateResponse200Type> {
        return this.session.call(openapiProxyStaffRule4UpdateRequest, requestBody);
    }

    public event_reorder_markets(
        requestBody: OpenapiProxyStaffEventReorderMarketsParamsType
    ): Promise<OpenapiProxyStaffEventReorderMarketsResponse200Type> {
        return this.session.call(openapiProxyStaffEventReorderMarketsRequest, requestBody);
    }

    public event_reorder_selection(
        requestBody: ReorderSelectionsBodyType
    ): Promise<OpenapiProxyStaffEventReorderSelectionsResponse200Type> {
        return this.session.call(openapiProxyStaffEventReorderSelectionsRequest, requestBody);
    }

    public staff_event_possible_markets(
        requestBody: OpenapiProxyStaffPossibleMarketsParamsType
    ): Promise<PossibleMarketsType> {
        return this.session.call(openapiProxyStaffPossibleMarketsRequest, requestBody);
    }

    public updateEvent(requestBody: UpdateEventDataType): Promise<OpenapiProxyUpdateEventResponse200Type> {
        return this.session.call(openapiProxyUpdateEventRequest, requestBody);
    }

    public createEvent(requestBody: CreateEventDataType): Promise<OpenapiProxyCreateEventResponse200Type> {
        return this.session.call(openapiProxyCreateEventRequest, requestBody);
    }

    public createParticipant(
        requestBody: OpenapiProxyStaffCreateParticipantParamsType
    ): Promise<OpenapiProxyStaffCreateParticipantResponse200Type> {
        return this.session.call(openapiProxyStaffCreateParticipantRequest, requestBody);
    }

    public getParticipants(requestBody: OpenapiProxyStaffGetParticipantParamsType): Promise<ParticipantsType> {
        return this.session.call(openapiProxyStaffGetParticipantRequest, requestBody);
    }

    public updateParticipants(
        requestBody: ParticipantsUpdateBodyType
    ): Promise<OpenapiProxyStaffUpdateParticipantsResponse200Type> {
        return this.session.call(openapiProxyStaffUpdateParticipantsRequest, requestBody);
    }
    public createSelection(
        requestBody: OpenapiProxyStaffCreateSelectionParamsType
    ): Promise<OpenapiProxyStaffCreateSelectionResponse200Type> {
        return this.session.call(openapiProxyStaffCreateSelectionRequest, requestBody);
    }

    public staff_selection_multi_update(
        requestBody: UpdateMultiSelectionParams
    ): Promise<OpenapiProxyStaffUpdateMultiSelectionResponse200Type> {
        return this.session.call(openapiProxyStaffUpdateMultiSelectionRequest, requestBody);
    }

    public postNetDeposit(body: OpenapiProxyStaffNetDepositParamsType): Promise<NetDepositResponseType> {
        return this.session.call(openapiProxyStaffNetDepositRequest, body);
    }

    public deleteCardRealex(
        params: OpenapiProxyStaffDeleteCardRealexParamsType
    ): Promise<OpenapiProxyStaffDeleteCardRealexResponse200Type> {
        return this.session.call(openapiProxyStaffDeleteCardRealexRequest, params);
    }

    public setSrgStatus(
        body: OpenapiProxyStaffSetSrgStatusParamsType
    ): Promise<OpenapiProxyStaffSetSrgStatusResponse200Type> {
        return this.session.call(openapiProxyStaffSetSrgStatusRequest, body);
    }

    public setPofStatus(
        body: OpenapiProxyStaffSetPofStatusParamsType
    ): Promise<OpenapiProxyStaffSetPofStatusResponse200Type> {
        return this.session.call(openapiProxyStaffSetPofStatusRequest, body);
    }

    public setComplianceRestriction(
        body: OpenapiProxyStaffSetComplianceRestrictionParamsType
    ): Promise<OpenapiProxyStaffSetComplianceRestrictionResponse200Type> {
        return this.session.call(openapiProxyStaffSetComplianceRestrictionRequest, body);
    }

    /**
     * @deprecated - Use getCompetitions()
     */
    public getCompetitionsBySportId(sportId: string): Promise<CompetitionsType> {
        // return this.session.call(openapiProxyStaffCompetitionsRequest, {sport_id: sportId});
        return this.getCompetitions({
            requestBody: {
                sport: sportId,
            },
        });
    }

    public getCompetitions(data: OpenapiProxyStaffGetCompetitionsParamsType): Promise<CompetitionsType> {
        return this.session.call(openapiProxyStaffGetCompetitionsRequest, data);
    }

    public getCompetitionById(
        data: OpenapiProxyStaffGetCompetitionByIdParamsType
    ): Promise<OpenapiProxyStaffGetCompetitionByIdResponse200Type> {
        return this.session.call(openapiProxyStaffGetCompetitionByIdRequest, data);
    }

    public patchCompetitionsReorder(params: CompetitionsReorderParamsType): Promise<CompetitionsReorderResponseType> {
        return this.session.call(openapiProxyStaffCompetitionsReorderRequest, params);
    }

    public patchCompetition(
        params: CompetitionUpdateParamsType
    ): Promise<OpenapiProxyStaffCompetitionUpdateResponse200Type> {
        return this.session.call(openapiProxyStaffCompetitionUpdateRequest, params);
    }

    public createCompetition(
        params: OpenapiProxyStaffCompetitionCreateParamsType
    ): Promise<OpenapiProxyStaffCompetitionCreateResponse200Type> {
        return this.session.call(openapiProxyStaffCompetitionCreateRequest, params);
    }

    public async getAllSports(): Promise<SportsListType> {
        //TODO - A temporary solution. The login form tries to send a request for sports too quickly
        // before the user token in the browser has changed from anonymous to stuff
        while ($appState.session.isAuthorized === false) {
            console.info('waiting for getAllSports ...');
            await timeout(1000);
        }

        return this.session.call(openapiProxyStaffSportsRequest, {});
    }

    public async getSport(sportId: string): Promise<OpenapiProxyStaffSportResponse200Type> {
        return this.session.call(openapiProxyStaffSportRequest, {
            sport_id: sportId,
        });
    }

    public createMarketForEvent(
        requestBody: OpenapiProxyStaffCreateEventMarketParamsType
    ): Promise<OpenapiProxyStaffCreateEventMarketResponse200Type> {
        return this.session.call(openapiProxyStaffCreateEventMarketRequest, requestBody);
    }

    public selectionsUnsettleGroup(
        requestBody: OpenapiProxyStaffUnsettleGroupParamsType
    ): Promise<OpenapiProxyStaffUnsettleGroupResponse200Type> {
        return this.session.call(openapiProxyStaffUnsettleGroupRequest, requestBody);
    }

    public getPriceMasterLadder(): Promise<OpenapiProxyStaffPriceMasterLadderResponse200Type> {
        return this.session.call(openapiProxyStaffPriceMasterLadderRequest, {});
    }

    public getMarketTemplates(sportId: string): Promise<OpenapiProxyStaffGetMarketTemplatesResponse200Type> {
        return this.session.call(openapiProxyStaffGetMarketTemplatesRequest, {
            requestBody: {
                sport_id: sportId,
            },
        });
    }

    public patchMarketTemplate(
        params: OpenapiProxyStaffMarketTemplateUpdateParamsType
    ): Promise<OpenapiProxyStaffMarketTemplateUpdateResponse200Type> {
        return this.session.call(openapiProxyStaffMarketTemplateUpdateRequest, params);
    }

    public createMarketTemplate(
        params: OpenapiProxyStaffCreateMarketTemplateParamsType
    ): Promise<OpenapiProxyStaffCreateMarketTemplateResponse200Type> {
        return this.session.call(openapiProxyStaffCreateMarketTemplateRequest, params);
    }

    public patchMarketTemplateSelections(
        params: OpenapiProxyStaffMarketTemplateSelectionsUpdateParamsType
    ): Promise<OpenapiProxyStaffMarketTemplateSelectionsUpdateResponse200Type> {
        return this.session.call(openapiProxyStaffMarketTemplateSelectionsUpdateRequest, params);
    }

    public patchMarketTemplateSelectionsReorder(
        params: OpenapiProxyStaffMarketTemplateSelectionsReorderParamsType
    ): Promise<OpenapiProxyStaffMarketTemplateSelectionsReorderResponse200Type> {
        return this.session.call(openapiProxyStaffMarketTemplateSelectionsReorderRequest, params);
    }

    public patchMarketTemplatesReorder(
        params: OpenapiProxyStaffMarketTemplateReorderParamsType
    ): Promise<OpenapiProxyStaffMarketTemplateReorderResponse200Type> {
        return this.session.call(openapiProxyStaffMarketTemplateReorderRequest, params);
    }

    public postMarketTemplateSelectionCreate(
        params: OpenapiProxyStaffMarketTemplateSelectionsCreateParamsType
    ): Promise<OpenapiProxyStaffMarketTemplateSelectionsCreateResponse200Type> {
        return this.session.call(openapiProxyStaffMarketTemplateSelectionsCreateRequest, params);
    }

    public setPlayBreak(
        requestBody: OpenapiProxyStaffSetPlayBreakParamsType
    ): Promise<OpenapiProxyStaffSetPlayBreakResponse200Type> {
        return this.session.call(openapiProxyStaffSetPlayBreakRequest, requestBody);
    }

    public getRealityCheck(
        requestBody: OpenapiProxyStaffGetRealityCheckParamsType
    ): Promise<OpenapiProxyStaffGetRealityCheckResponse200Type> {
        return this.session.call(openapiProxyStaffGetRealityCheckRequest, requestBody);
    }

    public setRealityCheck(
        requestBody: OpenapiProxyStaffSetRealityCheckParamsType
    ): Promise<OpenapiProxyStaffSetRealityCheckResponse200Type> {
        return this.session.call(openapiProxyStaffSetRealityCheckRequest, requestBody);
    }

    public setSelfExclusion(
        requestBody: OpenapiProxyStaffSetSelfExclusionParamsType
    ): Promise<OpenapiProxyStaffSetSelfExclusionResponse200Type> {
        return this.session.call(openapiProxyStaffSetSelfExclusionRequest, requestBody);
    }

    public requestReactivationSelfExclusion(
        requestBody: OpenapiProxyStaffRequestReactivationSelfExclusionParamsType
    ): Promise<OpenapiProxyStaffRequestReactivationSelfExclusionResponse200Type> {
        return this.session.call(openapiProxyStaffRequestReactivationSelfExclusionRequest, requestBody);
    }

    public reactivateSelfExclusion(
        requestBody: OpenapiProxyStaffReactivateSelfExclusionParamsType
    ): Promise<OpenapiProxyStaffReactivateSelfExclusionResponse200Type> {
        return this.session.call(openapiProxyStaffReactivateSelfExclusionRequest, requestBody);
    }

    public staffPatchUserPersonalDetail(
        params: OpenapiProxyStaffPatchUserPersonalDetailParamsType
    ): Promise<OpenapiProxyStaffPatchUserPersonalDetailResponse200Type> {
        return this.session.call(openapiProxyStaffPatchUserPersonalDetailRequest, params);
    }

    public async sportGradeAdd(params: OpenapiSocketApiStaffSportGradesAddParamsType): Promise<void> {
        await this.session.call(openapiSocketApiStaffSportGradesAddRequest, params);
    }

    public auditEvent(
        body: OpenapiProxyStaffAuditEventParamsType
    ): Promise<OpenapiProxyStaffAuditEventResponse200Type> {
        return this.session.call(openapiProxyStaffAuditEventRequest, { requestBody: body.requestBody });
    }

    public getLiabilities(
        params: OpenapiProxyStaffGetLiabilitiesParamsType
    ): Promise<OpenapiProxyStaffGetLiabilitiesResponse200Type> {
        return this.session.call(openapiProxyStaffGetLiabilitiesRequest, params);
    }

    public getLiabilitiesMultiples(
        params: OpenapiProxyStaffGetLiabilitiesMultiplesParamsType
    ): Promise<OpenapiProxyStaffGetLiabilitiesMultiplesResponse200Type> {
        return this.session.call(openapiProxyStaffGetLiabilitiesMultiplesRequest, params);
    }

    public async getCampaigns(): Promise<CampaignsListType> {
        const response = await this.trpcClient.client.bonusCampaignsRouter.getBonusCampaings.mutate();

        if (response.status === 200) {
            return response.body;
        }

        throw new Error(`Failed to get bonus campaigns: ${response.body.message}`);
    }
}
